// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-descriptions[data-v-4710e527]{padding:3% 3% 0 3%}.defaultNumber[data-v-4710e527]{width:30px}", ""]);
// Exports
module.exports = exports;
